export enum NavId {
  Section1 = "Section1",
  Section2 = "Section2",
  Section3 = "Section3",
  Section4 = "Section4",
  Section5 = "Section5",
  Section6 = "Section6",
  Section7 = "Section7",
  Section8 = "Section8",
  Section9 = "Section9",
  Section10 = "Section10",
  Section11 = "Section11",
}

export enum NavLabel {
  Section1 = "Home",
  Section2 = "Founder’s Story",
  Section3 = "Our Mission",
  Section4 = "Scriber Pro X",
  Section5 = "Emotional AI Framework",
  Section6 = "Null",
  Section7 = "For Organizations",
  Section8 = "Contact & Team",
  Section9 = "Contact",
  Section10 = "Team",
  Section11 = "Blog",
}

export const NavLabelsMap: Record<NavId, string> = {
  [NavId.Section1]: "Home",
  [NavId.Section2]: "Founder’s Story",
  [NavId.Section3]: "Our Mission",
  [NavId.Section4]: "Scriber Pro X",
  [NavId.Section5]: "Emotional AI Framework",
  [NavId.Section6]: "Null",
  [NavId.Section7]: "For Organizations",
  [NavId.Section8]: "Contact & Team",
  [NavId.Section9]: "Contact",
  [NavId.Section10]: "Team",
  [NavId.Section11]: "Blog",
};

export interface ILink {
  id: NavId;
  value: string;
}
